import { render, staticRenderFns } from "./EventOtpForm.vue?vue&type=template&id=59044998&scoped=true&"
import script from "./EventOtpForm.vue?vue&type=script&lang=js&"
export * from "./EventOtpForm.vue?vue&type=script&lang=js&"
import style0 from "./EventOtpForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EventOtpForm.vue?vue&type=style&index=1&id=59044998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59044998",
  null
  
)

export default component.exports